export const VALID_ATTEST_STATUS = ['Paid', 'Approved', 'Rejected', 'Processing'];

export const LOAN_STATUS_OPTIONS = [
  { label: 'Funded', value: 'FUNDED' },
  { label: 'Paid Off', value: 'PAID_OFF' },
  { label: 'Paid Off Buyout', value: 'PAID_OFF_BUYOUT' },
  { label: 'Retracted', value: 'RETRACTED' },
];

export const LOAN_SUB_TYPE_OPTIONS = [
  'Fix and Flip (1-4)',
  'Fix and Flip Pro (1-4)',
  'Groundup (1-4)',
  'Multifamily Bridge (5+)',
  'Single Property Rental',
  'Single Property Multifamily Term',
  'Single Property Mixed Use',
  'Rental Portfolios',
  'Multifamily Term Portfolios',
  'Mixed Use Portfolios',
  'Stabilized Bridge',
  'Other Bridge',
  'Other Rental',
].map(value => ({ label: value, value }));

export enum ServicingTransferTabs {
  SERVICING_TRANSFER = 'SERVICING_TRANSFER',
  BOARDED = 'BOARDED',
};

export enum PrincipalAmortizationTabs {
  AMORTIZATION = 'AMORTIZATION',
};
